import PrefixEnum from '../prefixes'

export default Object.freeze({
    'yvonne-pferrer.gymondo.fitness': PrefixEnum.STRONG_MIND_BODY,
})
